import http from './http';

export const login = (user) => http.post('/auth/login', user);

export const logoff = () => http.post('/auth/logoff');

export const validateSession = (requestData) =>
  http.post('/auth/validate', requestData, { timeout: 10000 });
